// extracted by mini-css-extract-plugin
export default {"customConfirmBtn":"TwoFactorPopup_customConfirmBtn__COEf6","cancelBtn":"TwoFactorPopup_cancelBtn__ILoOQ"};